import { useEffect, useRef } from "react";
import { useClientBookingContext } from "@/contexts/clientBookingContext";
import { BookingStep } from "@/types/bookingTypes";
import { getSelectedProvider } from "@/utils/booking";

// make sure the provider selected is always eligible for current services
export default function useBookingProviderSelection() {
  const {
    step,
    setSelectedProvider,
    eligibleProviders,
    selectedProvider,
    selectedServices,
  } = useClientBookingContext();

  const previousServices = useRef(selectedServices);

  useEffect(() => {
    const isServicesStep = step === BookingStep.SERVICES;
    const isProviderSelectionStep =
      step === BookingStep.AVAILABILITY_AND_PROVIDER_SELECTION;

    const servicesHaveChanged = selectedServices !== previousServices.current;
    previousServices.current = selectedServices;

    if (isProviderSelectionStep) {
      const provider = getSelectedProvider(
        eligibleProviders,
        selectedProvider?.id
      );
      setSelectedProvider(provider);
    } else if (isServicesStep && servicesHaveChanged) {
      setSelectedProvider(null);
    }
  }, [
    step,
    eligibleProviders,
    selectedProvider,
    setSelectedProvider,
    selectedServices,
  ]);
}
